/** @format */
import isPropValid from '@emotion/is-prop-valid';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { CriteriaBox, CriteriaBoxProps } from './components/criteria-box';
import { styles } from './criteria-list.styles';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface CriteriaListProps {
    /**
     * Optional title to display before the list of criteria
     */
    title?: string;

    /**
     * List of criteria to show
     */
    criteriaBoxes: CriteriaBoxProps[];

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;

    /**
     * Handler for removing an item from the list
     *
     * @param index the index of the item to remove
     */
    onRemove?: (criteriaBox: CriteriaBoxProps) => void;
}

const StyledCriteriaList = styled('ul').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const CriteriaList: FunctionComponent<CriteriaListProps> = ({
    title,
    criteriaBoxes,
    onRemove,
    'data-testid': dataTestId = 'criteria-list',
    ...otherProps
}: CriteriaListProps) => {
    return (
        <StyledCriteriaList
            criteriaBoxes={criteriaBoxes}
            data-testid={dataTestId}
            {...otherProps}
        >
            {/* eslint-disable-next-line react/jsx-no-leaked-render -- Legacy code: do not use as an example. */}
            {title && <h3>{title}</h3>}
            {criteriaBoxes.map((criteriaBox, index) => (
                <CriteriaBox
                    // eslint-disable-next-line react/no-array-index-key -- Legacy code: do not use as an example.
                    key={index}
                    label={criteriaBox.label}
                    className="criteria-box"
                    criteriaLabel={criteriaBox.criteriaLabel}
                    onRemove={() => {
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions, @typescript-eslint/prefer-optional-chain -- Legacy code: do not use as an example.
                        onRemove && onRemove(criteriaBox);
                    }}
                />
            ))}
        </StyledCriteriaList>
    );
};
